import React from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';
import moment from 'moment';
import { Marker, Popup } from 'react-leaflet';
import globals from '../../../globals/communityGlobals';
import postCodeAnywhereLocation from '../../../propTypes/external/postCodeAnywhereLocation';
import locationsForPosting from '../../../propTypes/entities/locationsForPosting';
import { appSettingsPropTypes } from '../../../propTypes/entities/appSettings';
import { RAGSTATUS_AMBER_FROMINTERVAL, RAGSTATUS_RED_FROMINTERVAL } from '../../../settings/constants/appSettings';

const locale = globals.getArea('dailyPlanning');

const formatHour = date =>
  moment(date)
    .utcOffset(0, true)
    .format(globals.timeFormats.short);

const ClinicianMarker = ({ posting, location, appSettings, clinicianColor }) => {
  const icon = L.divIcon({
    className: `clinician-color-${clinicianColor} allocateIcons rag ${(posting.ragCapacity >
      appSettings[RAGSTATUS_RED_FROMINTERVAL] &&
      'red') ||
      (posting.ragCapacity > appSettings[RAGSTATUS_AMBER_FROMINTERVAL] && 'amber') ||
      'green'}`,
    iconSize: [30, 48],
    iconAnchor: [23, 48],
    popupAnchor: [0, -55],
    html: 'add_location',
  });
  const { availabilities: timeSlots = [] } = posting;
  const popupContent = (
    <div className="clinician-info">
      {[
        <div key={`clinicianMarkerPopupHeader${posting.clinicianId}`}>
          <h5 className="popover-title">{posting.clinicianName}</h5>
          <span className="title-sub">{posting.grade.name}</span>
          <span>
            {locale.getMsg('visitsCompleted', [posting.visitsCompleted.toString(), posting.visitsTotal.toString()])}
          </span>
        </div>,
        timeSlots.map(({ id, startDate, endDate }) => (
          <div key={`clinicianMarkerPopupTimeSlot${posting.clinicianId + id}`} className="info-timeslot">
            {`${formatHour(startDate) + (startDate === endDate ? '' : ` - ${formatHour(endDate)}`)}`}
          </div>
        )),
        <div key={`clinicianMarkerPopupFooter${posting.clinicianId}`} className="title-sub">
          {posting.clinicianPhoneNumber}
        </div>,
      ]}
    </div>
  );

  return (
    <Marker
      payload={<h5 className="popover-title">{posting.clinicianName}</h5>}
      zIndexOffset={1}
      icon={icon}
      position={[location.latitude, location.longitude]}
    >
      <Popup>{popupContent}</Popup>
    </Marker>
  );
};

ClinicianMarker.propTypes = {
  clinicianColor: PropTypes.string.isRequired,
  appSettings: appSettingsPropTypes.isRequired,
  posting: locationsForPosting.isRequired,
  location: postCodeAnywhereLocation.isRequired,
};

export default ClinicianMarker;
